import React, { useEffect } from 'react';
import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition';
import "./speechRecognition.css"
import speechBtn from "../assets/speechDtc.svg"

const Dictaphone = (props) => {
    const { transcript, listening, resetTranscript, browserSupportsSpeechRecognition } = useSpeechRecognition();

    const { setQuestion } = props;
    useEffect(() => {
        if (transcript) {
            setQuestion(transcript);
        }
    }, [transcript, setQuestion]);


    if (!browserSupportsSpeechRecognition) {
        return <span>Browser doesn't support speech recognition.</span>;
    }


    const startListening = () => {
        // Clear the input box when starting to speak
        setQuestion('');
        resetTranscript();
        if (props.langOpt === 'Japanese') {
            SpeechRecognition.startListening({ continuous: true, language: 'ja-JP' });
        } else {
            SpeechRecognition.startListening({ continuous: true, language: 'en-US' });
        }
    };
    const stopListening = () => {
        SpeechRecognition.stopListening();
        resetTranscript();
    };

    return (
        <div className="mic-container">
            {!listening &&
                <img className="mic-button" src={speechBtn} alt="mic-start" onClick={startListening} ></img>
            }
            {listening && <div className="circle" onClick={stopListening}>
                <img
                    src="./microphoneListning.png" // Replace with your microphone image path
                    alt="Microphone"
                    className="microphone"
                />
            </div>}
        </div>
    );
};
export default Dictaphone;